<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div :class="['button-reveal', isCard ? 'card-button-reveal' : '', isAnnotation ? 'button-annotation' : '']" ref="buttonRef" @click.stop :style="[{ '--theme-color': themeColor, marginRight: info.info.buttonStyle === 'one' && !isLeft ? '5px' : '' }, { marginRight: info.info.bindingFunction === 'field-show' && !isLeft ? '10px' : '' }]">
    <template v-if="info.info.bindingFunction === 'qrCode' || info.info.bindingFunction === 'lookQrCode'">
      <el-dropdown @command="onQrcodeCommand">
        <span>
          <buttonStyle :info="info" :isTable="isTable" :themeColor="themeColor" :size="size" />
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <template v-if="info.info.bindingFunction === 'qrCode' && widgetDataObj.qrcodetypes">
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(2)"
                command="minstatic"
                >生成小程序端静态二维码</el-dropdown-item
              >
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(3)"
                command="mindynamic"
                >生成小程序端动态二维码</el-dropdown-item
              >
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(4)"
                command="h5static"
                >生成H5端静态二维码</el-dropdown-item
              >
              <el-dropdown-item
                v-if="widgetDataObj.qrcodetypes.includes(5)"
                command="h5dynamic"
                >生成H5端动态二维码</el-dropdown-item
              >
            </template>
            <!-- 生成查看二维码 -->
            <template v-if="info.info.bindingFunction === 'lookQrCode' && widgetDataObj.lookqrcodetypes">
              <el-dropdown-item command="lookministatic" v-if="widgetDataObj.lookqrcodetypes.includes(1)"
                >生成小程序查看二维码</el-dropdown-item
              >
              <el-dropdown-item command="lookh5static" v-if="widgetDataObj.lookqrcodetypes.includes(2)"
                >生成H5端查看二维码</el-dropdown-item
              >
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
    <template v-else-if="info.info.bindingFunction === 'field-show' && info.info.showFieldInfo && info.info.showFieldInfo.fieldShowType === 'single'">
      <div class="button-reveal-chekc-field">
        <el-checkbox v-model="info.info.showFieldInfo.fieldShowAll" @change="changeShowField">{{ info.info.text ? info.info.text : handleDiffText }}</el-checkbox>
      </div>
    </template>
    <template v-else-if="info.info.bindingFunction === 'img-import'">
      <el-popover width="200" :disabled="info.info.imgImportOther && info.info.imgImportOther.type === 'ai'" v-model="isViewImgImport" class="btn-popover" ref="btnPop" trigger="click" popper-class="img-import-btn-pop">
        <template #reference>
          <div>
            <buttonStyle @click="goImgAi" :info="info" :isTable="isTable" :themeColor="themeColor" :size="size" />
          </div>
        </template>
        <div class="img-import-content">
          <div v-for="(item, itemidx) in info.info.imgImportInfo" :key="itemidx" class="img-import-content-item" @click="goImportImg(item)">
            {{ item.name }}
          </div>
          <div class="img-import-content-item">
            <el-checkbox v-model="removeNonChineseCharactersFromFileHits">去除文件名中的非汉字</el-checkbox>
          </div>
        </div>
      </el-popover>
      <input type="file" hidden ref="inputRef" multiple @change="onFileSelect" />
    </template>
    <template v-else-if="info.info.bindingFunction === 'continue' || info.info.bindingFunction === 'again'">
      <el-popover class="btn-popover" placement="top-start" trigger="hover" :disabled="info.info.insideInfo.questionData.length < 2">
        <div class="all-out-table">
          <div v-for="item in info.info.insideInfo.questionData" :style="{
            background: item.value === 'all'? themeColor : '',
            color: item.value === 'all'? '#fff' : '',
          }" @click="goAnswer(item)" class="all-out-table-btn" :key="item.value">
            {{ item.title }}
          </div>
        </div>
        <template #reference>
          <buttonStyle :info="info" :isTable="isTable" :themeColor="themeColor" :size="size" @btnClick="handleCommand" />
        </template>
      </el-popover>
    </template>
    <template v-else-if="info.info.bindingFunction === 'container-btn'">
      <el-popover class="btn-popover" ref="btnPop" trigger="click" @show="popShow" popper-class="container-btn-pop">
        <template #reference>
          <buttonStyle :info="info" :isTable="isTable" :themeColor="themeColor" :size="size" />
        </template>
        <div class="container-btn-list-l" v-if="isAppenBtnPop">
          <template v-if="info.info.todoList">
            <template v-for="(btn, idx) in todoList" :key="idx">
              <buttonItem 
                v-bind="$props" 
                :info="{ info: btn }" 
                @appPrint="$emit('appPrint', $event)"
                @change-check-field="$emit('change-check-field', $event)"
                @updateTable="$emit('updateTable', $event)"
                @to-nav="$emit('to-nav', $event)"
                @open-appDialog="$emit('open-appDialog', $event)"
                @edit-user-info="$emit('edit-user-info', $event)"
                @uploadBlock="$emit('uploadBlock', $event)"
                @openAppInitiate="$emit('openAppInitiate', $event)"
                @custom-scene="$emit('custom-scene', $event)"
                @tableDetail="tableDetailItem"
                @progress-show="$emit('progress-show', $event)"
                @progress-status="$emit('progress-status', $event)"
                @open-dictionary="$emit('open-dictionary', $event)" 
                @openPrint="$emit('openPrint', $event)"
                @dataArchiving-btn="$emit('dataArchiving-btn', $event)" 
                @qrCode-btn="$emit('qrCode-btn', $event)" 
                @blockchain-btn="$emit('blockchain-btn', $event)" 
                @dataLog-btn="$emit('dataLog-btn', $event)" 
                @edit-btn="$emit('edit-btn', $event)" 
                @todo-inside="$emit('todo-inside', $event)"
                @todo-outside="$emit('todo-outside', $event)" 
                @del-btn="$emit('del-btn', $event)" 
                @app-print="$emit('app-print', $event)"
              />
            </template>
          </template>
        </div>
      </el-popover>
    </template>
    <template v-else-if="info.info.bindingFunction === 'choose-btn'">
      <template v-if="isOpenChoose">
        <div class="choose-btn">
          <div class="choose-btn-item choose-btn-all" @click="chooseBtnItem('all')">
            <i class="WSiconfont WSicon-quanxuan"></i>
            <span>全选</span>
          </div>
          <div class="choose-btn-item choose-btn-cancle" @click="chooseBtnItem('cancle')">
            <i class="WSiconfont WSicon-shanchu3"></i>
            <span>取消</span>
          </div>
        </div>
      </template>
      <template v-else>
        <buttonStyle @click="chooseBtn" :info="info" :isTable="isTable" :themeColor="themeColor" :size="size" />
      </template>
    </template>
    <template v-else>
      <template v-if="!blockchainChange && !approveChange">
        <!-- 批量操作 -->
        <el-dropdown
          trigger="click"
          v-if="info.info.bindingFunction === 'all-action'"
          @command="handleCommand"
        >
          <span class="all-todo" :class="`btn-${info.info.buttonStyle}`" :style="btnBg">
            <i
              :class="`iconfont ${handleDiffTodo('icon')}`"
              v-if="info.info.buttonStyle === 'two'"
            ></i>
            <span v-if="info.info.buttonStyle !== 'three'">批量操作</span>
            <el-tooltip
              v-if="info.info.buttonStyle === 'three'"
              :content="info.info.text ? info.info.text : handleDiffTodo('text')"
              popper-class="btn-tips"
              placement="bottom"
            >
              <i :class="`iconfont ${handleDiffTodo('icon')}`"></i>
            </el-tooltip>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="all-in" v-if="isAllData.import"
                >批量导入</el-dropdown-item
              >
              <el-dropdown-item command="all-del" v-if="isAllData.delete"
                >批量删除</el-dropdown-item
              >
              <el-dropdown-item command="all-edit" v-if="isAllData.batchupdate"
                >批量修改</el-dropdown-item
              >
              <el-dropdown-item command="all-approve" v-if="pageId === '2'"
                >批量审批</el-dropdown-item
              >
              <el-dropdown-item
                command="all-out-table-condition"
                v-if="panduanShow() && isAllData.export"
                >批量导出报表</el-dropdown-item
              >
              <el-dropdown-item
                command="all-out-annex"
                v-if="
                  panduanShow() && isAllData.exportmyfile
                    ? isAllData.exportmyfile
                    : isAllData.exportfile
                "
                >批量导出附件</el-dropdown-item
              >
              <el-dropdown-item
                command="all-upload"
                v-if="
                  isAllData.uploadmyblockchainid
                    ? isAllData.uploadmyblockchainid
                    : isAllData.uploadblockchainid
                "
                >上传区块链</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!-- 批量操作结束 -->
        <template v-else>
          <el-popover class="btn-popover" :style="getBtnStyle" placement="bottom" v-model="isTableView" trigger="click" :disabled="(!(panduanShow() && isAllData.export) && info.info.bindingFunction === 'all-out-table') || (info.info.bindingFunction !== 'all-out-table')">
            <div class="all-out-table">
              <div v-for="item in outTableBList" :style="{
                background: item.value === 'all'? themeColor : '',
                color: item.value === 'all'? '#fff' : '',
              }" @click="goOutTable(item.value)" class="all-out-table-btn" :key="item.value">
                {{ item.title }}
              </div>
            </div>
            <template #reference>
              <buttonStyle :info="info" @click.stop="handleCommand(info.info.bindingFunction)" :isTable="isTable" :themeColor="themeColor" :size="size" />
            </template>
          </el-popover>
        </template>
      </template>
      <div v-else class="upload-block">
        <template v-if="blockchainChange">
          <el-button size="mini" @click="closeUploadBlock">取消</el-button>
          <el-button size="mini" type="primary" @click="blockchainUpload"
            >进行存证</el-button
          >
        </template>
        <template v-if="approveChange">
          <el-button size="mini" @click="closeApprove">取消</el-button>
          <el-button size="mini" type="primary" @click="allApprove(true)"
            >全部处理</el-button
          >
          <el-button size="mini" type="primary" @click="allApprove(false)"
            >处理选中</el-button
          >
        </template>
      </div>
    </template>
    <template v-if="isAnnotation">
      <span class="button-annotation-icon">
        <el-tooltip effect="dark" content="提示" placement="top">
          <i class="WSiconfont WSicon-bangzhuzhongxin" @click="openTips"></i>
        </el-tooltip>
      </span>
    </template>
    <!-- 批量下载附件 -->
    <accessory ref="accessoryRef" :date="tableListInfo.tableData" v-if="downLoadShow"></accessory>
    <!-- 批量操作 -->
    <batchDialog
      :visible="batch.visible"
      :date="batch"
      :approvalId="applyInfo.id"
      @batch="batchRet"
      @close="batch = { visible: false, title: '', operate: '' }"
    />
    <!-- 数据筛选 -->
    <transactionFilter
      v-model:isFilter="isFilter"
      v-model:condition="query"
      :approvalId="applyInfo.id"
      @goFilter="goFilter"
    />
    <!-- 填写表单 -->
    <oaAddExamineInput
      v-model:isViews="addDataShow"
      :applyInfo="applyInfo"
      :pageType="pageType"
      :coverVal="coverVal"
      :isAllAdd="isAllAdd"
      @updateTable="$emit('updateTable')"
    />
    <!-- 短信验证窗口 -->
    <smsVerifiction
      ref="smsVerifi"
      :approvalId="applyInfo.id"
      type="1"
      :exportType="exportType"
      @smsRefersh="smsRefersh"
      @close="toSmsVerifi = false"
      v-show="toSmsVerifi == true"
    />
    <!-- 应用任务 -->
    <applyAction v-model:isViews="isApplyAction" :applyInfo="applyInfo" />
    <!-- 批量审批查看 -->
    <batchView
      v-if="isBatch"
      v-model:isView="isBatch"
      :info="{
        app: isAllData,
        selected: multipleSelection,
        headerList: listCheck,
        searchInfo: searchCriteriaData,
      }"
      :allBatch="allBatch"
      @resetRefresh="batchRefresh"
    />
    <!-- 显示字段弹窗 -->
    <el-dialog
      title="显示字段"
      append-to-body
      v-model="syllableVisible"
      width="530px"
    >
      <div v-if="listInfo.tableStyle === 'list'">
        <el-checkbox
          v-model="item.checked"
          v-for="item in listCheck"
          :key="item.title"
          >{{ item.name }}</el-checkbox
        >
      </div>
      <div v-else>
        <el-checkbox
          v-model="item.syllable.checked"
          v-for="item in cardFilePosition"
          :key="item.syllable.title"
          >{{ item.syllable.name }}</el-checkbox
        >
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="mini" @click="syllableVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="syllableConfirm">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-if="popUps" class="popUps" append-to-body top="0" v-model="popUps" :width="popUpsObj.popUps.w + 'px'">
        <iframe :style="{height:popUpsObj.popUps.h + 'px'}" :frameborder="0" seamless scrolling="auto" allowtransparency="true" id="iframe" :height="popUpsObj.popUps.h"  width="100%" :src="popUpsObj.url" />
    </el-dialog>
    <!-- 打印预览 -->
    <print-box 
      ref="printBox" 
      :key=" 'print' + printBoxKey"
      v-model:isView="printBoxShow"
      v-model:isOpen="printBoxOpen"
      :title="printTitle" 
      :formdata="printFormdata"
      :detailConfig="printBoxConfig"
      @close="printBoxKey++"></print-box>
      <!-- 报表打印 -->
      <reportPrint 
        v-if="isShowReportPrint" 
        v-model:isView="isShowReportPrint"
        :isApp="isApp"
        :appid="approvalId || applyInfo.approvalId || applyInfo.id"
        :isPageAllData="isPageAllData"
        :btnInfo="info.info.insideInfo"
        :data="exportData"
      />
    <!-- 刷卡弹窗 -->
    <swipeIndex ref="swipeIndexRef" @swipeRet="swipeRet" />
    <!-- 数据解析loading -->
    <install-progress class="fullscreen-progress" :visible="showProgress" :text="progressText" />
    <dataPresentation @close="dataPresentationClose" v-model:isView="isAppenImgImportTips" :info="tempImgTips" />
    <annotationTips ref="tipsRef" />
    <successLoading :append-to-body="true" v-if="animationStyle && animationStyle.value !== 2" :show="animationVisible" :animationStyle="animationStyle" />
  </div>
</template>

<script>
import { filePreview } from '@/api/global.js';
import { axiosBase } from '@/api/api'
import { getConfigFromUrl } from "@/api/utils.js"
import { addcochain, openapiGetapproval, getuserapprovinglist, updateapprovingbyfeild } from '@/port/clientSide/oaExamineAudit'
import { sheetDefaultConfig } from '@/components/common/detailEdit/detailConfig.js'
import { deletebycondition, batchupdatedata } from '@/port/clientSide/workbench'
import { openapiValidateapprovalsms } from '@/port/clientSide/workbench'
import { openapiUpdateuserccapprovingstatus, transapprovingfilebyapproval } from '@/port/clientSide/oaExamine'
import { openapiGetoptions } from "@/port/admins/wordbook";
import { getShowconfig } from '@/api/drage'
import { getAddCoverval, getParamsLists, isConditionAppen, getTMbulkImportParam, sleep } from '@/components/schoolInstrument/component/mutual/common/config'
import { isValidateapprovaltimeswitch, getcuruserroles, getcuruserorgs } from '@/components/schoolInstrument/mixins/utils'
import { cloneDeep } from 'lodash'
import { showMyDialog } from "@/components/clientSide/workbench/bulkImportCpn/uploadDialog.js";
import { importimageandattachment } from '@/port/schoolInstrument/appConfig.js'
import { getschool } from '@/port/admins/organizationSpace'
import { dealText } from '@/api/common'
import { getapproving } from '@/port/clientSide/oaExamineAudit.js'
import { addapprovaling } from '@/port/clientSide/applicationRouting.js'
import { ElMessage } from 'element-plus'
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import qs from 'qs'
import Axios from 'axios'
import EventBus from '@/components/schoolInstrument/mixins/EventBus';

import iconMixin from '@/components/common/icon/common.js'
import chuanshenMixin from '@/components/schoolInstrument/component/mutual/common/common'
import successLoading from '@/components/common/successLoading.vue';
import { defineAsyncComponent } from 'vue';
import { MY_CONSTANTS } from '@/util/constants'
import dayjs from 'dayjs'
export default {
  name: 'buttonComp',
  mixins: [iconMixin, chuanshenMixin],
  data () {
    return {
      // 批量操作数据
      batch: {
        visible: false,
        title: '',
        operate: ''
      },
      isTableView: false,
      outTableBList: [
        {
          id: 1,
          value: 'cur',
          title:'导出当前页面'
        },
        {
          id: 2,
          value: 'all',
          title:'导出所有数据'
        },
        {
          id: 3,
          value: 'before',
          title:'条件导出'
        },
      ],
      // 上传附件显示
      downLoadShow: false,
      // 数据筛选显示
      isFilter: false,
      query: [],
      // 上传区块链
      blockchainChange: false,
      // 填写表单显示
      addDataShow: false,
      // 打开表单时 需要带进去的值
      coverVal:{},
      syllableVisible: false,
      cardCheckSyllable: [],
      listCheckSyllable: [],
      toSmsVerifi: false,
      exportType: '1',
      isApplyAction: false,
      // 是否批量审批
      approveChange: false,
      // 是否点击了全部处理
      allBatch: false,
      // 是否打开批量审批弹窗
      isBatch: false,
      searchCriteriaData: null,
      // 弹窗
      popUps: false,
      popUpsObj: {
        popUps: {},
        url:''
      },
      printBoxShow: false, // 打印预览数据的显示隐藏
      printBoxOpen: false, // 打印预览弹窗的显示隐藏
      printTitle: null,
      printBoxConfig: sheetDefaultConfig, // 传入打印盒子的配置
      printBoxKey: 0, // 用于刷新组件
      printFormdata: {}, // 传入打印盒子的数据
      spaceid:this.$route.query.spaceid,
      upaceid:this.$route.query.upaceid,
      ruleList: [], // 本表的模板
      isSpace: false,
      isUpace: false,
      isShowReportPrint: false, // 是否显示批量打印报表
      isPageAllData: false, // 导出的数据是否是当前页面所有的
      exportData: [], // 要导出的数据
      isApp: false, 
      // 是否为批量新增
      isAllAdd: false,
      skey: '',
      isAppenBtnPop: false,
      showProgress: false, //数据解析loading
      pageType: '',
      exportBtnType: '', //导出按钮类型
      isViewImgImport: false,
      removeNonChineseCharactersFromFileHits: false,
      tempImportInfo: {},
      progressText: '数据解析中...',
      isAppenImgImportTips: false,
      tempImgTips: {},
      tMbulkImportParam: {},
      AiDropData: null,
      voiceMessage: '',
      isOpenChoose: false,
      animationStyle: {
        animationList: [{ "name": "样式一", "text": "提交完成123", "value": 0 }, { "name": "样式二", "text": "提交完成", "value": 1 }, { "name": "样式三", "text": "提交完成", "value": 2 }],
        value: 0
      },
      animationVisible: false,
    }
  },
  props: {
    // 按钮组件的信息
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 选择应用的信息
    applyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 列表数组选中的数据
    multipleSelection: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 获取权限数据
    powerData: {
      type: Object,
      default: () => {
        return {
          '1': {},
          '0': {}
        }
      }
    },
    // 页面的id
    pageId: {
      type: String,
      default: '1'
    },
    // 配置卡片模式选中的字段
    cardFilePosition: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 配置列表模式选中的字段
    listCheck: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 列表的配置信息
    listInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 数据筛选的条件
    searchCriteria: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 列表信息
    tableListInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 填写表单的权限
    writePower: {
      type: [Object, Boolean],
      default: () => {
        return {}
      }
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    // 页面权限
    isAddPower: {
      type: Object,
      default: () => ({})
    },
    // 当前选择的组织id和name 
    currentOrg: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      default: () => ({})
    },
    widgetDataObj: {
      type: Object,
      default:()=>({})
    },
    // 默认不需要
    size: {
      type: String,
      default:'14px'
    },
    // 默认不需要
    isTable: {
      type: Boolean,
      default: false
    },
    approvalId: {
      type: Number,
    },
    organizationalParameters: {
      type: Object,
      default:()=>({})
    },
    ruledata: {
      type: Object,
      default:()=>({})
    },
     // 是否是详情页
    isDetaile: {
      type: Boolean,
      default: false
    },
    // 是否是卡片
    isCard: {
      type: Boolean,
      default: false
    },
    // 是否是仪表盘
    isDashboard: {
      type: Boolean,
      default: false
    },
    screenRef: {
      type: Array,
      default: ()=>([])
    },
    otherToolScreenRef: {
      type: Array,
      default: ()=>([])
    },
    tableData: {
      type: Object,
      default: ()=>({})
    },
    customData: {
      type: Array,
      default: ()=>([])
    },
    // 消息发布组件的数据
    detailListData: {
      type: Array,
      default: ()=>([])
    },
    fontStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    querys: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isLeft:{
      type: Boolean,
      default: false
    },
    cardUser: {
      type: Object,
      default: () => {}
    },
    screenFixQuery:{
      type: Object,
      default: () => {}
    },
    orgList:{
      type: Array,
      default: () => []
    },
    tableConfig:{
      type: Object,
      default: () => ({})
    },
    isAiCheck: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: ''
    },
    searchCompQuery: {
      type: Object,
      default: ()=> ({})
    },
    isSearchStatus: {
      type: Boolean,
      default: false
    },
  },
  components: {
    batchDialog: defineAsyncComponent(() => import('@/components/clientSide/workbench/batchDialog/index')),
    accessory: defineAsyncComponent(() => import('@/components/clientSide/workbench/accessory')),
    reportPrint: defineAsyncComponent(() => import('@/components/clientSide/workbench/reportPrint')),
    transactionFilter: defineAsyncComponent(() => import('@/components/clientSide/workbench/transationFilter/index')),
    oaAddExamineInput: defineAsyncComponent(() => import('./oaAddExamineInput.vue')),
    applyAction: defineAsyncComponent(() => import('./applyAction.vue')),
    smsVerifiction: defineAsyncComponent(() => import('@/components/clientSide/common/smsVerifiction.vue')),
    batchView: defineAsyncComponent(() => import("@/components/clientSide/workbench/batchView/index")),
    PrintBox: defineAsyncComponent(() => import("@/components/common/detailEdit/excel/printBox")),
    swipeIndex: defineAsyncComponent(() => import("../swipe/index")),
    buttonStyle: defineAsyncComponent(() => import("./buttonStyle.vue")),
    buttonItem: defineAsyncComponent(() => import("./index.vue")),
    successLoading,
    InstallProgress: defineAsyncComponent(() => import('@/components/common/installLoading.vue')),
    dataPresentation: defineAsyncComponent(() => import('@/components/schoolInstrument/common/dataPresentation.vue')),
    annotationTips: defineAsyncComponent(() => import('@/components/schoolInstrument/common/annotationTips.vue')),
  },
  created () {
    const skey = this.$route.query.skey || this.$route.params.skey
    if (skey) {
      this.skey = skey
    }
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    } else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
    EventBus.on('openBtn', this.findIdOpen)
  },
  mounted() {
    this.$nextTick(() => {
      if (this.info.info.bindingFunction === 'field-show' && this.info.info.showFieldInfo && this.info.info.showFieldInfo.fieldShowType === 'single') {
        this.changeShowField(this.info.info.showFieldInfo.fieldShowAll)
      }
    })
  },
  beforeUnmount() {
    EventBus.off('openBtn', this.findIdOpen)
  },
  methods: {
    async btnEventTrigger() {
      const config = this.info.info.btnEventConfig
      if (config && config.animationType !== 2) {
        for (const ele of this.animationStyle.animationList) {
          ele.text = config[`animationText${ele.value + 1}`] || '修改成功'
        }
        this.animationStyle.value = config.animationType
        this.animationVisible = true
        await sleep(2000)
      }
      if (config && config.type === 'copy') {
        await this.copyData()
      } else if (config && config.type === 'edit') {
        const linked = config.linked
        if (linked.length === 0) {
          this.$message.warning('请配置修改字段')
          return
        }
        for (const ele of linked) {
          let value = ''
          if (ele.condition === 'vant') {
            if (['relation-user', 'organization', 'roule'].includes(ele.controlType)) {
              value = []
            } else {
              value = ''
            }
          } else if (ele.condition === 'custom') {
            value = ele.customValue
          } else if (ele.condition === 'curUser') {
            const userMsg = JSON.parse(localStorage.getItem('userMsg'))
            value = [{
              userId: userMsg.userId,
              name: userMsg.realname
            }]
          } else if (ele.condition === 'curOrg') {
            value = await getcuruserorgs()
          } else if (ele.condition === 'curDate') {
            value = dayjs().format('YYYY-MM-DD')
          } else if (ele.condition === 'curRole') {
            value = await getcuruserroles()
          }
          for (const data of this.multipleSelection) {
            const params = {
              approvalId: this.curAppId,
              approvingId: data.approvingId,
              value,
              feild: ele.control
            }
            await updateapprovingbyfeild(params)
          }
        }
      }
      if (config && config.animationType === 2) {
        ElMessage({ type: 'success', message: config.animationText3 })
      }
      this.animationVisible = false
      this.$emit('updateTable')
    },
    async copyData() {
      if (this.multipleSelection.length === 0) return
      for (const ele of this.multipleSelection) {
        const approvingId = ele.approvingId
        // 获取formdata
        const res = await getapproving({
          approvalId: this.applyInfo.approvalId || this.applyInfo.id,
          approvingId,
          person: 0
        })
        if (res.code === 0) {
          let formdata = res.data.formdata
          formdata = typeof formdata === 'string' ? JSON.parse(formdata) : formdata
          console.log(formdata,'formdataformdata')
          
          const params = {
            ...formdata,
            install: {"isfree":0,"telltime":0,"departdistinct":0,"approverdistinct":0,"addCheckNameUnique":{}},
            to: [{"personformpers":[],"type":6,"way":1,"user":[],"approsel":0,"freestyle":0,"controller":"","mode":1,"follow":0,"tell":0,"comment":0,"sign":0}],
            cto: [],
            linkedMessage: [],
            fillquery: {},
            approvalId: this.applyInfo.approvalId || this.applyInfo.id,
          }
          await addapprovaling(params)
        }
      }
    },
    chooseBtn() {
      this.isOpenChoose = true
      this.$emit('chooseBtnItem', { type: 'action', value: this.isOpenChoose })
    },
    chooseBtnItem(type) {
      if (type === 'cancle') {
        this.isOpenChoose = false
        this.$emit('chooseBtnItem', { type: 'action', value: this.isOpenChoose })
      } else {
        this.$emit('chooseBtnItem', { type: 'choose', value: this.isOpenChoose })
      }
    },
    goImgAi() {
      if (this.info.info.imgImportOther.type !== 'ai') return
      const info = {
        config: this.info.info.imgImportOther,
        list: this.info.info.imgImportInfo,
        data: this.tableListInfo.tableData,
      }
      this.$emit('goImgAi', info)
    },
    findIdOpen({ id, message }) {
      this.voiceMessage = message || ''
      if (this.info.i === id) {
        this.handleCommand(this.info.info.bindingFunction)
      }
    },
    openTips() {
      const config = this.info.info.annotationInfo || {}
      const name = dealText({
        text: config.formData || '',
        commonData: this.$store.state.userData,
        customData: this.$store.state.doorCustomData,
      })
      config.formData = name
      this.$refs.tipsRef.open(config)
    },
    changeShowField(val) {
      // eslint-disable-next-line vue/no-mutating-props
      this.info.info.showFieldInfo.fieldShowAll = val
      this.$emit('change-check-field', { isHide: val, showFieldList: this.info.info.showFieldInfo.showFieldList, id: this.info.i })
    },
    dataPresentationClose() {
      this.$emit('updateTable')
    },
    goImportImg(item) {
      this.tempImportInfo = item
      this.$refs.inputRef.click()
    },
    async onFileSelect(e) {
      const approvinglds = this.tableListInfo.tableData.map(item => item.approvingId)
      if (approvinglds.length === 0) {
        this.$message.error('暂无数据')
        return
      }
      this.showProgress = true
      this.progressText = '上传中...'
      const files = e.target.files
      // 检测上传图片的格式 只能支持jpg,gif,bmp,png
      const imgType = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png']
      const formdataList = []
      for (const file of files) {
        console.log(file,'filesfilesfiles')
        if (!imgType.includes(file.type) && this.tempImportInfo.type && this.tempImportInfo.type.includes('image')) {
          this.$message.warning('只能上传jpg,gif,bmp,png格式的图片')
          this.showProgress = false
          return
        }
        const formData = new FormData()
        formData.append('file', file)
        formdataList.push(formData)
      }
      const fileUrl = []
      for (const ele of formdataList) {
        const res = await this.userfileUpload(ele)
        fileUrl.push(res)
      }
      const config = {
        importimageconfig: this.tempImportInfo,
        fileUrl,
        isChinese: this.removeNonChineseCharactersFromFileHits ? 1 : 0,
      }
      config.approvalId = this.applyInfo.approvalId || this.applyInfo.id || this.approvalId
      config.approvingIds = approvinglds
      const res = await importimageandattachment(config).catch(() => {
        this.showProgress = false
        this.$message.error('上传失败，请联系管理员')
      })
      if (res.code === 0) {
        const data = res.data
        data.total = formdataList.length
        this.tempImgTips = data
        this.showProgress = false
        this.isAppenImgImportTips = true
      } else {
        this.$message.error(res.msg)
        this.showProgress = false
      }
      this.$refs.inputRef.value = ''
    },
    async userfileUpload (formData) {
      let user = localStorage.getItem('user')
      if (user) user = JSON.parse(user)
      const token = user.accesstoken
      const url = this.$apiurl + '/userfile/upload?accesstoken=' + token
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      const res = await Axios.post(url, formData, config)
      return res.data
    },
    popShow() {
      if (this.isAppenBtnPop === false) {
        this.isAppenBtnPop = true
      }
    },
    tableDetailItem(row, dataInfo, type = 'app-detail') {
      if(this.isTable){
        this.$emit('tableDetail', row, dataInfo)
      } else {
        this.$emit('tableDetail', row, dataInfo, type)
      }
    },
    editUser() {
      if (this.isTable || this.isDashboard || this.multipleSelection.length === 1) {
        const info = this.info.info.editUser || {}
        this.$emit('edit-user-info', info)
      } else {
        this.$message.warning('只能选择一条数据')
      }
    },
    async swipeRet (val) {
      console.log('回来做操作', val)
      switch (this.info.info.bindingFunction) {
        case 'swipeAdd':
          {
            const payload = {type: 1,approvalId: this.applyInfo.id}
            const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
            const flag = await isValidateapprovaltimeswitch(payload, upaceId)
            if (flag) return
            this.coverVal = val
            this.isAllAdd = false
            this.pageType = ''
            this.addDataShow = true
          }
          break
        case 'swipeUp':
          {
            let str = '/clientSide/application'
            if (Object.keys(this.organizationalParameters).length !== 0) {
              val = {
                ...val,
                ...this.organizationalParameters
              }
            }
            const ob1 = {
              approvalId: this.applyInfo.id,
              iId: 14,
              source: 'user',
              name: this.applyInfo.name,
              navShow: false,
              dataId: 14,
              search: JSON.stringify(val),
              swipe: true //刷卡后打开发起页标记
            }
            str += ('?' + qs.stringify(ob1))
            const obj = {
              approvalId: this.applyInfo.id,
              datatype: 1,
              iId: 14,
              popUps: {
                customSize: 65,
                diaSize: '80%',
                h: 800,
                open: 2,
                w: 1700
              },
              search: str
            }
            this.openAppInitiate(obj)
          }
          break
      }
    },
    async goImport(type) {
      if (!this.isAllData.import) {
        this.$message.warning('您没有权限')
        return
      }
      let bulkImportMutat
      if (type === 'all') {
        // this.$store.commit('bulkImportMutat', true);
        bulkImportMutat = true
      } else if (type === 'person') {
        // this.$store.commit('bulkImportMutat', false);
        bulkImportMutat = false
      } else {
        if (this.pageId === '7') {
          // this.$store.commit('bulkImportMutat', true);
          bulkImportMutat = true
        } else {
          // this.$store.commit('bulkImportMutat', false);
          bulkImportMutat = false
        }
      }
      let importSet = {}
      if (this.applyInfo.baseset) {
        const baseset = JSON.parse(this.applyInfo.baseset)
        if (baseset.importSet) importSet = baseset.importSet
      }
      // 导入传参
      this.importLinked(this.info.info)
      let date = []
      for (const ele of this.multipleSelection) {
        const data = await this.getObs(this.info.info.insideInfo, ele)
        date.push(data.obs)
      }
      if (date.length > 0) {
        localStorage.setItem('TMbulkImportObs', JSON.stringify(date))
      }
      const obj = await getTMbulkImportParam(this.applyInfo.id, bulkImportMutat, importSet)
      if (obj && obj.openType !== 'old' && obj.openType !== 'new') {
        this.$emit('open-appDialog', obj)
      }
    },
    async goCustomImport (data, fileUrl) {
      this.AiDropData = data
      let importSet = {}
      let bulkImportMutat = false // 默认打开个人发起
      if (this.applyInfo.baseset) {
        const baseset = JSON.parse(this.applyInfo.baseset)
        if (baseset.importSet) importSet = baseset.importSet
      }
      let allInCustomInfo = {}
      if (this.info.info.allInCustomInfo) {
        allInCustomInfo = cloneDeep(this.info.info.allInCustomInfo)
      }
      if (allInCustomInfo.importType === 'file') {
        let customData = []
        if (this.homeId) {
          // 当前页面的自定义参数
          customData = this.$store.state.doorCustomDataObj[this.homeId()] || []
        } else {
          customData = this.$store.state.doorCustomData
        }
        // 导入方式为文件的处理方式
        if (allInCustomInfo.isAiDrop && allInCustomInfo.aiTips) {
          allInCustomInfo.aiTips = dealText({
            text: allInCustomInfo.aiTips,
            commonData: this.$store.state.userData,
            customData: customData
          })
        }
        const uploadDialog = showMyDialog({
          title: "上传文件",
          aiDropFile: fileUrl,
          isAiDrop: allInCustomInfo.isAiDrop,
          aiTips: allInCustomInfo.aiTips,
          approvalId: this.applyInfo.id,
          onConfirm: async (file, isAiDrop) => {
            console.log("上传文件:", file);
            // 执行上传逻辑
            if (file) {
              allInCustomInfo.uplaodTemplate = !isAiDrop ? file : ''
              // ai拖拽导入
              if (isAiDrop) {
                await this.importLinked(this.info.info, null, [], file)
              }
              // 导入传参
              const obj = await getTMbulkImportParam(this.applyInfo.id, bulkImportMutat, importSet, allInCustomInfo)
              if (obj && obj.openType !== 'old' && obj.openType !== 'new') {
                this.$emit('open-appDialog', obj)
              }
            }
            uploadDialog.destroy(); // 关闭弹窗
          },
          onCancel: () => {
            uploadDialog.destroy();
          }
        });
      } else {
        const obj = await getTMbulkImportParam(this.applyInfo.id, bulkImportMutat, importSet, allInCustomInfo)
        this.tMbulkImportParam = obj || {}
        if (allInCustomInfo.importModeValue === 1 && allInCustomInfo.importType === 'table' && allInCustomInfo.isChooseUpdate) {
          let content = [];
          if (this.applyInfo && this.applyInfo.property) {
            const defaultChooseField = allInCustomInfo.defaultChooseField || []
            content = JSON.parse(this.applyInfo.property).map(item => {
              return {
                checked: defaultChooseField.find(iten => { return iten === `${item.title}_${item.type}` }) ? true : false,
                name: item.name,
                title: item.title,
                type: item.type,
              }
            })
          }

          this.batch = {
            visible: true,
            title: '更新导入',
            operate: 'customImport',
            dateLen: this.multipleSelection.length,
            batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
            center: content,
            batchfixQuery: this.screenFixQuery
          }
          return false
        } else {
          // 导入传参
          await this.importLinked(this.info.info, null, [], this.AiDropData)
          if (obj && obj.openType !== 'old' && obj.openType !== 'new') {
            this.$emit('open-appDialog', obj)
          }
        }
      }
    },
    // 选择字段更新导入
    async customUpdateImport (info) {
      // 导入传参
      if (this.tMbulkImportParam.openType !== 'old' && this.tMbulkImportParam.openType !== 'new') {
        this.tMbulkImportParam.chooseField = info.center
        this.tMbulkImportParam.dataFrom = info.radio
        this.tMbulkImportParam.info = this.info
        if (this.AiDropData) {
          this.tMbulkImportParam.AiDropData = this.AiDropData
        }
        if (info.radio === 1) {
          await this.importLinked(this.info.info, null, info.center, this.AiDropData)
        } else if (info.radio === 2) {
          const datalist = this.tableListInfo?.tableData || []
          await this.importLinked(this.info.info, datalist, info.center, this.AiDropData)
        } else if (info.radio === 3) {
          this.tMbulkImportParam.time = info.time
        }
        this.$emit('open-appDialog', this.tMbulkImportParam)
      }
    },
    async goAdd(isAll = false) {
      const payload = {type: 1,approvalId: this.applyInfo.id}
      const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
      const flag = await isValidateapprovaltimeswitch(payload, upaceId)
      if (flag) return

      if ((this.writePower && JSON.stringify(this.writePower) === '{}') || !this.writePower) {
        this.$message.warning('您没有权限')
        return;
      }
      const newlyAdded = this.info.info.newlyAdded || []
      const newlyAddCustomed = this.info.info.newlyAddCustomed || []
      const screens = this.screenRef
      const currentOrg = this.currentOrg
      let _customData = this.customData || []
      if (this.homeId) {
        // 当前页面的自定义参数
        _customData = [...(this.$store.state.doorCustomDataObj[this.homeId()] || []), ..._customData]
      }
      const obj = getAddCoverval({ newlyAdded, newlyAddCustomed, screens, currentOrg, customData: _customData })
      console.log('新增传参返回', obj)
      if (Object.keys(obj).length !== 0) {
        this.coverVal = obj
      }
      this.pageType = this.info.info.pageType || ''
      this.isAllAdd = isAll
      this.addDataShow = true
    },
    openAppInitiate(opt) {
      console.log('回传修改数据', opt)
      opt.pageType = this.info.info.pageType || ''
      this.$emit('openAppInitiate', opt)
    },
    goOutTable(type) {
      this.allOutTable(type)
      this.isTableView = false
    },
    async getAppPrintInfo() {
      const len = this.multipleSelection.length
      if ((!this.isTable) && len === 0 || len > 1) {
        let str = ''
        len === 0 ? str = '请选择数据' : str = '只能选择一条数据'
        this.$message.warning(str)
        return
      }
      const approvalId = Object.keys(this.applyInfo).length === 0 ? this.approvalId : this.applyInfo.id
      let obj = {
        approvalId
      }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      const { code, data } = await openapiGetapproval(obj)
      if (code === 0) {
        // 获取本应用的模板
        this.ruleList = JSON.parse(data.property)
        let pagesets = JSON.parse(data.pageset)
        if (pagesets && pagesets.url) {
          pagesets = await getConfigFromUrl(this.$url + pagesets.url)
        }
        if (!Array.isArray(pagesets)) return
        const pageset = pagesets[3].printConfig.find(item => item.id === this.info.info.printId)
        if (pageset) {
          this.openPrintDia(pageset, approvalId)
        } else {
          this.$message.error('请选择打印模板')
        }
      }
    },
    async openPrintDia(printConfig, approvalId) {
      if (this.isTable) {
        // 是否从表格引用组件
        this.$emit('openPrint',{printConfig, approvalId})
      } else {
        if (this.multipleSelection.length === 1) {
          this.printBoxOpen = true
          const row = this.multipleSelection[0]
          this.printFormdata = await this.getFromdata(row, approvalId)
          this.printTitle = printConfig.canvasName
          // 兼容一下旧配置
          this.printBoxConfig = JSON.parse(JSON.stringify(this.compatibleSheetCongfig(printConfig)))
          
          // 判断是否有他表的数据
          if (printConfig.dataSource.formList && printConfig.dataSource.formList.length>0) {
            const obj = {
              printConfig: printConfig,
              printFormdata:this.printFormdata
            }
            const { otherData } = await DealPrintData.getOtherApproval(obj)
            this.printFormdata = { ...this.printFormdata, ...otherData }
            console.log(this.printFormdata, '其他表的返回')
          }
          // 获取一下联系人其他的数据和单选存储值的兼容
          this.printFormdata = await DealPrintData.getRelationUserInfo(JSON.parse(JSON.stringify(this.printFormdata)))
          this.printFormdata = await DealPrintData.dealRadioLabel(JSON.parse(JSON.stringify(this.printFormdata)), this.ruleList)
          setTimeout(() => {
            this.printBoxShow = true
          }, 500)

        } else if (this.multipleSelection.length === 0){
          this.$message.warning('请选择数据')
        } else {
          this.$message.warning('只能选择一条数据')
        }
      }
    },
    // 报表的打包下载
    getReportPrintInfo () {
      this.isShowReportPrint = true
      this.isApp = false
      const insideInfo = this.info.info.insideInfo
      if (insideInfo.datatype != 7) return this.$message.warning('请选择报表应用！')
      if (this.multipleSelection.length === 0) {
        this.isPageAllData = true
        this.exportData = this.tableListInfo.tableData
      } else {
        this.isPageAllData = false
        this.exportData = this.multipleSelection
      }
    },
    // 应用内报表的打包下载
    getAppReportPrintInfo () {
      this.isShowReportPrint = true
      this.isApp = true
      if (this.multipleSelection.length === 0) {
        this.isPageAllData = true
        this.exportData = this.tableListInfo.tableData
      } else {
        this.isPageAllData = false
        this.exportData = this.multipleSelection
      }
      console.log(this.info)
      console.log(this.applyInfo.approvalId, this.applyInfo.id, this.approvalId)
    },
    compatibleSheetCongfig (config) {
      let resultConfig = JSON.parse(JSON.stringify(config))
      if (resultConfig.sheetList.length > 0 && resultConfig.sheetList[0].sheets && resultConfig.sheetList[0].sheets.length > 0) {
        const sheetList = resultConfig.sheetList[0].sheets
        // 删除原来配置的 工作表
        delete resultConfig.sheetList[0].sheets
        // 旧的全局配置
        const sheetOldConfig = JSON.parse(JSON.stringify(resultConfig.sheetList[0]))
        sheetList.forEach(item => {
          // 将原来的全局配置分配给每个工作表
          if (resultConfig.sheetConfig === undefined) resultConfig.sheetConfig = {}
          resultConfig.sheetConfig[item.index] = sheetOldConfig
        })
        resultConfig.sheetList = sheetList
      }
      return resultConfig
    },
    // 处理一下本表的数据
    async getFromdata(rowData, approvalId) {
      let res = {}
      const query = {
        curpage: 0,
        pagesize: 0,
        approvingId: rowData.approvingId,
        approvalId
      }
      // 请求本表的数据
      const {data, code} = await getuserapprovinglist(query)
      if (code === 0) {
        const defaultData = {}
        res = JSON.parse(data[0].approving.formdata)
        const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
        defaultKeyList.forEach(item => {
          defaultData[item] = DealPrintData.handleDefaultKey(item, data[0])
        })
        res = { ...res, ...defaultData }
      }
      return res
    },
    handleCustomScene() {
      const { open, popUps } = this.info.info.insideInfo

      const custom = this.info.info.customScene
      const skey = this.$route.query.skey || this.$route.params.skey

      const url = '/customInstrument'
      let paramsList = cloneDeep(custom.paramsList || [] )
      let paramsLists = []
      // 页面入参
      if (paramsList.length > 0) {
        let customData = []
        if (this.customData && this.customData.length > 0) {
          customData = this.customData
        } else if (this.homeId) {
          // 当前页面的自定义参数
          customData = this.$store.state.doorCustomDataObj[this.homeId()] || []
        } else {
          customData = this.$store.state.doorCustomData
        }
        const obj = {
          paramsList: paramsList,
          customData,
          currentOrg: this.currentOrg,
          screen: this.screenRef,
          tableData: this.tableData
        }
        paramsLists = getParamsLists(obj)
      }
      const query = { showNav: false, name: custom.params, customDeskId: custom.id }
      if (skey) {
        query.skey = skey
      }
      if (paramsLists.length > 0) query.paramsList = JSON.stringify(paramsLists)
      if (open === 2 || open === 5) {
        // 弹窗
        this.$emit('custom-scene', {url:`${url}?${qs.stringify(query)}`,popUps, open, query})
      } else if (open === 3) {
        // 新窗口
        this.$openNewPage(url, query)
      } else if (open === 4) {
        // 当前窗口
        this.$router.push({path: url, query})
      } else {
        this.$message.error('请选择打开方式')
      }

    },
    onQrcodeCommand(value) {
      this.$emit('qrCode-btn',value)
    },
    // 短信验证
    smsVerifi (key, type, outType) {
      let obj = {
        approvalId: this.applyInfo.id,
        number: key // 验证参数为 1	个人数据查看短信验证 2 个人数据批量导出附件短信验证 3 个人数据批量导出报表短信验证 4 全校数据查看短信验证 5 全校数据批量导出附件短信验证 6 全校数据批量导出报表短信验证
      }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      console.log(outType, 'outType')
      openapiValidateapprovalsms(obj).then(res => {
        if (res.code === 0) {
          // bindcode 是否需要绑定手机号 smsverification 是否需要短信验证 phone 手机号
          if (res.data.smsverification && res.data.bindcode && !res.data.phone) {
            // 去绑定手机号
            this.toSmsVerifi = true
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.smsVerifi.iphoneBind({ isSmsView: true });
              }, 10);
            })
          } else if (res.data.smsverification && res.data.phone) {
            // 去验证
            this.toSmsVerifi = true
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.smsVerifi.openSmsVer(res.data.phone, this.toSmsVerifi ? { isSmsView: true } : '');
              }, 10);
            })
          } else {
            if (type === '1') {
              // 导出
              const par = { reportFormId: this.isAllData.reportFormId }
              if (this.spaceid) {
                par.spaceid = this.spaceid
              }
              else if (this.upaceid) {
                par.upaceid = this.upaceid
              }
              if (this.isPivot) {
                let center = []
                const pivotConfig = this.tableConfig.pivotConfig
                const checkFile = pivotConfig.checkFile
                for (const field of checkFile) {
                  const obj = {
                    type: field.type,
                    name: field.name,
                    title: field.title,
                  }
                  center.push(obj)
                }
                const obj = {
                  visible: true,
                  title: '导出',
                  operate: 'export',
                  dateLen: this.multipleSelection.length,
                  batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
                  center,
                  batchfixQuery: this.screenFixQuery,
                  isPivot: this.isPivot
                }
                // this.batch = obj
                this.$set(this, 'batch', obj)
              } else {
                axiosBase(par, "/api/getuserreport").then(res => {
                  let content = res.data.content || [];
                  this.batch = {
                    visible: true,
                    title: '导出',
                    operate: 'export',
                    dateLen: this.multipleSelection.length,
                    batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
                    center: content,
                    batchfixQuery: this.screenFixQuery
                  }
                })
              }
            } else if (type === '2') {
              this.downLoadShow = true;
              this.exportAnnex()
            }
          }
        }
      }).catch(err => {
        console.log('短信验证错误', err)
      })
    },
    panduanShow () {
      let whether = ''
      if ((this.applyInfo.id) != 10288 && (this.applyInfo.id) != 10318 &&
        (this.applyInfo.id) != 10156 &&
        (this.applyInfo.id) != 10345 &&
        (this.applyInfo.id) != 10344
      ) {
        whether = true
      } else {
        whether = false
      }
      return whether
    },
    smsRefersh (e) {
      this.isSmsView = false
      if (e === '1') {
        axiosBase({ reportFormId: this.isAllData.reportFormId }, "/api/getuserreport").then(res => {
          let content = res.data.content || [];
          this.batch = {
            visible: true,
            title: '导出',
            operate: 'export',
            dateLen: this.multipleSelection.length,
            batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
            center: content,
            batchfixQuery: this.screenFixQuery
          }
        })
      } else if (e === '2') {
        this.downLoadShow = true;
        this.exportAnnex()
      }
    },
    //- 获取当前表单的字段
    getFrom () {
      let that = this;
      const par = { approvalId: this.applyInfo.id }
      if (this.spaceid) {
        par.spaceid = this.spaceid
      }
      else if (this.upaceid) {
        par.upaceid = this.upaceid
      }
      axiosBase(par, "/openapi/getapproval").then(async res => {
        if (res.code === 0) {
          let field = JSON.parse(res.data.property);
          const appname = res.data.appname
          field = field.filter(val => {
            if (val.list && val.list.length > 0) val.list = (val.list).filter(items => { return items.type !== 'label' });
            return val.type !== 'label'
          });
          const list = getShowconfig(res.data.showconfig || '')
          list.splice(list.length - 1, 1)
          field = list.concat(field)

          // 遍历给每个有list 的参数加东西
          field = that.findAdd(field);


          // field.unshift({ name: '申请人', type: 'relation-user', title: '申请人', fatherType: '', tier: 1 },
          //   { name: '单号', type: 'text', title: '单号', fatherType: '', tier: 1 },
          //   { name: '状态', type: 'status', title: '状态', fatherType: '', tier: 1 },
          //   { name: '提交时间', type: 'date', title: '提交时间', fatherType: '', tier: 1 });
          let arrs = [];//- 最后转换的数据内容
          field.forEach((val) => {
            let date = {
              type: val.type,
              name: val.name,
              title: val.title,
              fatherType: val.fatherType,
              tier: val.tier
            };
            if (val.sels) date.sels = typeof val === 'string' ? JSON.parse(val.sels) : val.sels;
            // if (val.type !== 'details' && val.type !== 'new-rel-radio' && val.type !== 'ready-widget')
            arrs.push(date);
          });
          // 获取一下打印模板
          let printConfig
          if (res.data && res.data.pageset) {
            printConfig = JSON.parse(res.data.pageset)
            if (printConfig && printConfig.url) {
              printConfig = await getConfigFromUrl(this.$url + printConfig.url)
            }
          }
          this.$nextTick(() => {
            this.$refs.accessoryRef.setFromDatas(arrs, printConfig, appname);
          })
        }
      })
    },
    findAdd (val) {
      //- type代表当前数据，title代表fathertype值，val代表当前循环的list数据
      let new_array = [];//- 新数组
      let datas = JSON.parse(JSON.stringify(val));
      for (let index = 0; index < datas.length; index++) {
        if (['ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(datas[index].type) === -1) {
          //- 第一级fathertype补全
          if (datas[index].fatherType == undefined) {
            //- 说明字段fatherType不存在就要补全
            datas[index].fatherType = '';
          }
          //- 明细或者新版管联数据判断
          let list_one = datas[index].list;
          if (list_one && list_one.length > 0) {
            //- 可能是明细还是关联单选控件
            list_one.forEach((item) => {
              item.fatherType = datas[index].title + '_' + datas[index].type;
              item.name = datas[index].name + "." + item.name;
              //- 明细可能有第二层list数据
              let second_list = item.list;
              if (second_list && second_list.length > 0) {
                second_list.forEach((item2) => {
                  if (['ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(item2.type) === -1) {


                    item2.name = item.name + "." + item2.name;
                    item2.fatherType = datas[index].title + '_' + datas[index].type + "." + item.title + '_' + item.type;
                    item2.tier = 3;
                    new_array.push(item2);
                  }
                })
              } else {
                //- 说明没有下一层数据就直接加入数据
                if (['ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(item.type) === -1) {
                  item.tier = 2;
                  new_array.push(item);
                }
              }
            })
          } else {
            //- 当前没有没有明细数据或者关联数据(第一级)
            datas[index].tier = 1;
            new_array.push(datas[index]);
          }
        }

      }
      return new_array;
    },
    syllableConfirm () {
      // 字段显示 .sync双向绑定  修改传过来的数据
      this.syllableVisible = false
      this.$emit('update:cardFilePosition', this.cardFilePosition)
      this.$emit('update:listCheck', this.listCheck)
    },
    allOutTable(type) {
      if (!this.panduanShow() && !this.isAllData.export) {
        this.$message.warning('您没有权限')
        return
      }
      this.exportType = '1'
      this.exportBtnType = type
      if (this.pageId === '7') {
        this.smsVerifi(6, '1', type)
      } else if (this.pageId === '1') {
        this.smsVerifi(3, '1', type)
      } else {
        const par = { reportFormId: this.isAllData.reportFormId }
        if (this.spaceid) {
          par.spaceid = this.spaceid
        }
        else if (this.upaceid) {
          par.upaceid = this.upaceid
        }
        if (this.isPivot) {
          let center = []
          const pivotConfig = this.tableConfig.pivotConfig
          const checkFile = pivotConfig.checkFile
          for (const field of checkFile) {
            const obj = {
              type: field.type,
              name: field.name,
              title: field.title,
            }
            center.push(obj)
          }
          const obj = {
            visible: true,
            title: '导出',
            operate: 'export',
            dateLen: this.multipleSelection.length,
            batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
            center,
            batchfixQuery: this.screenFixQuery,
            isPivot: this.isPivot
          }
          this.batch = obj
        } else {
          axiosBase(par, "/api/getuserreport").then(res => {
            let content = res.data.content || [];
            this.batch = {
              visible: true,
              title: '导出',
              operate: 'export',
              dateLen: this.multipleSelection.length,
              batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
              center: content,
              batchfixQuery: this.screenFixQuery
            }
          })
        }
      }
    },
    async handleCommand (value) {
      console.log('点击按钮', value)
      // 不知道这里为什么return 信息发布组件不要走这步
      this.$emit('buttonCilck')
      if (this.isDashboard && !this.isDetaile) {
        this.$emit('retCard')
        return false
      }
      switch (value) {
        // 批量导入
        case 'edit-user':
          this.editUser()
          return
        case 'all-in':
          this.goImport('person')
          return;
        case 'all-in-custom':
          this.goCustomImport()
          return;
        case 'all-in-all':
          this.goImport('all')
          return;
        case 'all-in-person':
          this.goImport('person')
          return;
        // 批量删除
        case 'all-del':
          if (!this.isAllData.delete) {
            this.$message.warning('您没有权限')
            return
          }
          this.batch = {
            visible: true,
            title: '删除',
            operate: 'del',
            repeat: true,
            batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
            dateLen: this.multipleSelection.length,
            batchfixQuery: this.screenFixQuery
          }
          return;
        // 批量修改
        case 'all-edit':
          if (!this.isAllData.batchupdate) {
            this.$message.warning('您没有权限')
            return
          }
          this.batch = {
            visible: true,
            title: '修改',
            operate: 'update',
            repeat: true,
            batchQuery: { ...typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query, ...this.querys },
            dateLen: this.multipleSelection.length,
            batchfixQuery: this.screenFixQuery
          }
          return;
        // 批量审批
        case 'all-approve':
          if (!this.isAllData.batchadd) {
            this.$message.warning('您没有权限')
            return
          }
          this.searchCriteriaData = {
            approvalId:this.applyInfo.id,
            cateId:-1,
            curpage:this.tableListInfo.currentPage,
            key:"",
            pagesize:this.tableListInfo.tablePageSize,
            reportFormId:this.isAllData.reportFormId,
            type:1,
            status:"0",
            way:"0,1,2,4",
            querys:"{}",
            query:"{}"
          }
          this.approveChange = true
          return;
        // 批量导出报表
        case 'all-out-table':
          if (!(this.panduanShow() && this.isAllData.export)) {
            this.$message.warning('您没有权限')
            return
          }

          // 如果是全部数据 则选择powerData中索引为1的对象，否则选择索引为0的对象
          this.isTableView = true
          return;
        case 'all-out-table-condition':
          if (!(this.panduanShow() && this.isAllData.export)) {
            this.$message.warning('您没有权限')
            return
          }
          // 如果是全部数据 则选择powerData中索引为1的对象，否则选择索引为0的对象
          this.goOutTable('before')
          return;
        case 'btn-event':
          if (this.multipleSelection.length === 0) {
            ElMessage({ type: 'error', message: '请勾选数据' })
          }
          this.btnEventTrigger()
          return;
        // 批量导出附件 
        case 'all-out-annex':
          if (this.isAllData.exportmyfile ? !(this.isAllData.exportmyfile && this.panduanShow()) : !(this.isAllData.exportfile && this.panduanShow())) {
            this.$message.warning('您没有权限')
            return
          } 
          this.exportType = '2'
          if (this.pageId === '7') {
            this.smsVerifi(5, '2')
          } else if (this.pageId === '1') {
            this.smsVerifi(2, '2')
          } else {
            this.downLoadShow = true;
            this.exportAnnex()
          }
          return;
        // 上传区块链
        case 'all-upload':
          if (this.isAllData.uploadmyblockchainid ? !this.panduanShow() && !this.isAllData.uploadmyblockchainid : !this.panduanShow() && !this.isAllData.uploadblockchainid) {
            this.$message.warning('您没有权限')
            return
          }
          this.blockchainChange = true
          this.$emit('uploadBlock', true)
          // this.$emit('updateTable', {})
          return;
        // 填写表单
        case 'write-table':
          await this.goAdd(false)
          return;
        case 'all-write-table':
          await this.goAdd(true)
          return;
        // 站内应用
        case 'inside':
          this.dealBtnInside(2)
          return;
        // 字典
        case 'dictionary':
          {
            let info = this.info.info.dictionaryInfo
            const par = {
              optionsId: info.optionsId
            }
            const res = await openapiGetoptions(par)
            if (res.code === 0) {
              info = res.data
              this.$emit('open-dictionary', info)
            } else {
              this.$message.error(res.msg)
            }
          }
          return;
        // 站内应用
        case 'outside':
          if (this.skey) {
            this.openOutside(this.info.info)
          } else {
            this.dealBtnInside(3)
          }
          return;
        // 编辑
        case 'edit':
          this.$emit('edit-btn', this.info.info)
          return;
        case 'todoinside':
          {
            const _info = cloneDeep(this.info.info.insideInfo)
            _info.pageType = this.info.info.pageType || ''
            _info.isShowDialog = this.info.info.isShowDialog === undefined ? true : this.info.info.isShowDialog
            this.$emit('todo-inside', _info)
          }
          return;
        case 'todooutside':
          this.$emit('todo-outside', this.info.info.insideInfo)
          return;
        // 删除
        case 'del':
        this.$emit('del-btn')
          return;
        // 数据日志
        case 'dataLog':
          this.$emit('dataLog-btn')
          return;
        case 'app-comment':
          if (this.isTable) {
            this.$emit('tableDetail', 'app-comment', this.info.info)
          } else {
            if (this.multipleSelection.length === 1) {
              console.log(this.info.info,'this.info.info');
              
              this.$emit('tableDetail', this.multipleSelection[0], this.info.info, 'app-comment')
            } else if (this.multipleSelection.length === 0){
              this.$message.warning('请选择数据')
            } else {
              this.$message.warning('只能选择一条数据')
            }
          }
          return;
        case 'custom-scene':
          this.handleCustomScene()
          return;
        // 区块链
        case 'blockchain':
          this.$emit('blockchain-btn')
          return;
        // 二维码
        case 'qrCode':
          return;
        // 数据归档
        case 'dataArchiving':
          this.$emit('dataArchiving-btn')
          return;
        // 查看详情
        case 'app-detail':
          if (this.isTable) {
            this.$emit('tableDetail', 'app-detail', this.info.info)
          } else {
            if (this.multipleSelection.length === 1) {
              this.$emit('tableDetail', this.multipleSelection[0], this.info.info, 'app-detail')
            } else if (this.multipleSelection.length === 0){
              this.$message.warning('请选择数据')
            } else {
              this.$message.warning('只能选择一条数据')
            }
          }
          return;
        // 查看详情
        case 'app-print':
          if (this.info.info.printId === -1) {
            if (this.isTable) {
              this.$emit('app-print')
            } else {
              if (this.multipleSelection.length === 1) {
                this.$emit('appPrint', this.multipleSelection[0])
              } else if (this.multipleSelection.length === 0){
                this.$message.warning('请选择数据')
              } else {
                this.$message.warning('只能选择一条数据')
              }
            }
            return
          }
          if (this.isDetaile) {
            this.$emit('app-print', this.info.info.printId)
          } else {
            this.getAppPrintInfo()
          }
          return;
        // 批量打印报表
        case 'report-print':
          this.getReportPrintInfo()
          return
        // 批量下载应用内报表
        case 'app-report-print':
          this.getAppReportPrintInfo()
          return
        // 列表操作
        case 'list-todo':
          this.$emit('todo-list')
          return;
        case 'openAbility':{
          let customData = []
          if (this.customData && this.customData.length > 0) {
            customData = this.customData
          } else if (this.homeId) {
            // 当前页面的自定义参数
            customData = this.$store.state.doorCustomDataObj[this.homeId()] || []
          } else {
            customData = this.$store.state.doorCustomData
          }
          if(customData.length > 0 && this.info.info && this.info.info.abilityInfo && this.info.info.abilityInfo.paramQuesConfig && this.info.info.abilityInfo.paramQuesConfig.dataList) {
            // eslint-disable-next-line vue/no-mutating-props
            this.info.info.abilityInfo.paramQuesConfig.customData = customData
          }
          this.$emit('open-ability',this.info.info)
          return;
        }
        case 'toNav':
          this.$emit('to-nav',this.info.info.toNavInfo)
          return;
        // 数据筛选
        case 'data-screen':
          {
            let querys = []
            if (this.query.length === 0) {
              querys = JSON.parse(this.isAllData.query)
            } else {
              querys = this.query
            }
            let newQuerys = []
            querys.forEach(e => {
              if (e.checked) {
                if (e.type == 'radio' || e.type == 'checkbox') {
                  if (typeof e.sels == "string") {
                    e.sels = JSON.parse(e.sels)
                  }
                  e.value = []
                } else if (e.type == 'status') {
                  e.value = []
                } else if (e.type == 'data') {
                  // TODO
                }
                newQuerys.push(e)
              }
            });
            this.query = JSON.parse(JSON.stringify(newQuerys))
            this.isFilter = true
          }
          return
        // 显示字段
        case 'filed-show':
          this.syllableVisible = true
          return
        // 应用任务
        case 'apply-action':
          this.isApplyAction = true
          return
        // 待阅   已读
        case 'already-read':
          this.$emit('updateTable', { status: '1' })
          return
        // 待阅   未读
        case 'unread':
          this.$emit('updateTable', { status: '0' })
          return
        // 待阅   标记已读
        case 'all-already':
          this.handleAllReady()
          return
        // 刷卡/新增
        case 'swipeAdd':
          this.$refs.swipeIndexRef.open(this.info.info)
          return
        // 刷卡/修改
        case 'swipeUp':
          this.$refs.swipeIndexRef.open(this.info.info)
          return
        case 'continue':
        case 'again':
          this.handleAnswer(this.info)
          return
        // 数据解析
        case 'data-analysis':
          this.dataAnalysis()
          return
        // 开放能力
        case 'ability':
          this.$emit('open-ability',this.info.info)
          return
        // 下载
        case 'upload':
          this.$emit('usual', this.info.info.bindingFunction)
          break
        // 刷新
        case 'update':
          this.$emit('usual', this.info.info.bindingFunction)
          break
        // 放大
        case 'enlarge':
          this.$emit('usual', this.info.info.bindingFunction)
          break
        // 存储
        case 'memory':
          this.$emit('usual', this.info.info.bindingFunction)
          break
        case 'field-show':
          this.$emit('field-show')
          break
        case 'toCloud':
          this.openCloud()
          break
        case 'dataSynchronization':
          this.openDataSync()
          break
        case 'page-inner':
          this.openInnerPage(this.info.info)
          break
        case 'imageAnnotation':
          this.$emit('openImageAnnotation', this.info.info)
          break
      }
    },
    openInnerPage(info) {
      const row = this.multipleSelection[0] || this.tableData || {}
      const link = info.innerPageConfig.innerLink
      const query = {}
      const user = localStorage.getItem('user')
      if (user) {
        const token = JSON.parse(user).accesstoken
        query.accesstoken = token
      }
      for (const ele of link) {
        const title = ele.title
        query[ele.submitName] = row[title]
      }
      const url = `/previewfiles/${info.innerPageConfig.fileUrl}`
      const open = info.insideInfo.open
      if (open === 4) {
        // 原页面
        this.$router.push({ path: url, query })
      } else if (open === 3) {
        // 新页面
        const pathurl = MY_CONSTANTS.$apiurl + url
        window.open(`${pathurl}?${qs.stringify(query)}`, '_blank')
      } else if (open === 2 || open === 5) {
        const popUps = info.insideInfo.popUps
        const obj = {
          2: 'dialog',
          3: 'new',
          4: 'old',
          5: 'rightdia'
        }
        const dialogUrl = MY_CONSTANTS.$apiurl + url + '?' + qs.stringify(query)
        const param = {
          isVisible: true,
          dialogName: '页面嵌入',
          dialogWidth: popUps.w + 'px',
          dialogHeight: popUps.h + 'px',
          openType: obj[open],
          dialogUrl,
          customSize: popUps.customSize,
          diaSize: popUps.diaSize,
        }
        this.$emit('open-appDialog', param)
      }
    },
    openDataSync() {
      this.$emit('openDataSync', this.info.info, this.multipleSelection[0])
    },
    async openCloud() {
      const type = this.info.info.cloudType
      let chooseOpen = 'rightdia'
      const openObj = {
        2: 'dialog',
        3: 'new',
        4: 'old',
        5: 'rightdia'
      }
      if (this.info.info.insideInfo) {
        chooseOpen = openObj[this.info.info.insideInfo.open] || 'rightdia'
      }
      if (!type) return this.$message.error('请选择要跳转的网盘')
      let userMsg = localStorage.getItem("userMsg");
      if (userMsg) {
        userMsg = JSON.parse(userMsg)
        console.log(userMsg)
        const schoolId = userMsg.schoolMsg.schoolId
        const { code, data, msg } = await getschool({ schoolId: schoolId })
        if (code === 0) {
          const { openstorage } = data
          if (openstorage === 1) {
            let url = this.$cloudurl
            const user = localStorage.getItem('user')
            if (user) {
              const token = JSON.parse(user).accesstoken
              const schoolname = userMsg.schoolMsg.name
              const username = userMsg.realname
              url += `?accesstoken=${token}&storagetype=${type}&schoolname=${schoolname}&username=${username}`
              if (chooseOpen === 'old') {
                let query = { url: url }
                this.$router.push({
                  path: "/bearing",
                  query
                })
              } else if (chooseOpen === 'new') {
                window.open(url, '_blank')
              } else if (chooseOpen === 'dialog' || chooseOpen === 'rightdia') {
                const popUps = this.info.info.insideInfo.popUps
                const obj = {
                  dialogUrl: url,
                  openType: chooseOpen,
                  isVisible: true,
                  dialogName: '网盘',
                  diaSize: popUps.diaSize,
                  customSize: 100,
                  dialogHeight: `${popUps.h}px`,
                  dialogWidth: `${popUps.w}px`
                }
                this.$emit('open-appDialog', obj)
              }
            }
          } else {
            this.$message.warning('网盘未开启')
          }
        } else {
          this.$message.error(msg)
        }
      }
    },
    // ai回答问题
    goAnswer(val){
      console.log("val---",val);
      const text = val.bindinf
      this.$emit('goAnswer', text)
    },
    handleAnswer(item){
      if(item.info.insideInfo.questionData.length > 1) return
      const text = item.info.insideInfo.questionData[0].bindinf
      this.$emit('goAnswer', text)
    },
    async dealBtnInside(link) {
      // 处理选择站内应用
      // datatype 1表单 5仪表盘
      const item = this.info.info.insideInfo
      item.link = link || item.link
      console.log("item==",item);
      console.log("this.multipleSelection==", this.info.info.insideInfo.linked ,this.multipleSelection);
      if (this.multipleSelection.length === 0 && this.info.info.insideInfo.linked.length !== 0) {
        const isUseAppFiled = this.info.info.insideInfo.linked.find(item => {
          // 只有表单字段才需要判断
          return item.datatype !== 'custom' && item.orgName === 'filed'
        })
        if (isUseAppFiled) {
          this.$message.warning('请选择数据')
          return
        }
      }
      const row = this.multipleSelection[0] || []
      item.detailValue = this.multipleSelection
      item.pageType = this.info.info.pageType || ''
      item.isShowDialog = this.info.info.isShowDialog === undefined ? true : this.info.info.isShowDialog
      
      // ai小易点击进入的需要穿多条数据
      if([27, 28].includes(item.appIid) || this.info.info?.insideInfo?.datatype === 8 || item.channel === 'ai'){
        // 获取最新答题结果（避免渲染没完成获取的数据不完整）
        this.$emit('getResultMsg')
        this.dealInside(row, item, this.multipleSelection)
      } else {
        this.dealInside(row, item)
      }
      console.log(this.info.info.chooseEdit && this.info.info.chooseEdit.isOpen && this.multipleSelection.length,'asdasdasd')
      if (this.info.info.chooseEdit && this.info.info.chooseEdit.isOpen && this.multipleSelection.length) {
        for (const ele of this.multipleSelection) {
          const customize = this.info.info.chooseEdit.link.customize || []
          const from = this.info.info.chooseEdit.from || []
          this.setUpdateFeild({ li: from, type: 'from', row: ele }, {})
          this.setUpdateFeild({ li: customize, type: 'customize', row: ele }, {})
        }
      }
    },
    async setUpdateFeild(opt, submitValue) {
      const { li, type } = opt
      if(li.length === 0) return
      const approvalId = this.applyInfo.id || this.applyInfo.approvalId
      const row = opt.row
      for (const ele of li) {
        let control = ''
        let value = null
        if (type === 'from') {
          value = submitValue[ele.source]
          control = ele.FormList.find(f => f.name === ele.conditionValue)
        } else {
          value = ele.value
          control = {
            fatherType: ele.conditionValue,
          }
        }
        const param = {
          approvalId,
          approvingId: row.approvingId,
          feild: control.fatherType,
          value
        }
        await updateapprovingbyfeild(param)
      }
    },
    // 处理标记已读
    handleAllReady () {
      let obj = { status: 1 };
      if (this.applyInfo.id) obj.approvalId = this.applyInfo.id;
      openapiUpdateuserccapprovingstatus(obj).then(res => {
        if (res.code === 0) {
          this.$emit('updateTable', {})
        }
      }).catch(e => { console.log('标记已读接口请求错误', e) })
    },
    // 数据解析
    dataAnalysis(){
      this.$confirm('是否对未解析的数据进行解析', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj = {};
        this.progressText = '数据解析中...'
        if (this.applyInfo.id) obj.approvalId = this.applyInfo.id;
        this.showProgress = true;
        transapprovingfilebyapproval(obj).then(res => {
          this.showProgress = false;
          if (res.code === 0) {
            this.$message.success('数据解析成功')
            this.$emit('updateTable', {})
          } else {
            this.$message.error(res.msg)
          }
        }).catch(e => {
          this.showProgress = false;
          console.log('数据解析接口请求错误', e)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消数据解析'
        });          
      });      
    },
    // 批量返回操作
    batchRet (val) {
      // 批量操作返回的执行
      if (this.batch.operate === 'del') {
        if (val.radio === 1) {
          // 删除选中的
          this.delCehckList(1)
        } else {
          this.delCehckList(2, val)
        }
      } else if (this.batch.operate === 'update') {
        if (val.radio === 1) {
          this.updateCheckList(1, val)
        } else if (val.radio === 2) {
          this.updateCheckList(2, val)
        } else {
          this.updateCheckList(3, val)
        }
      } else if (this.batch.operate === 'export') {
        this.exportexcel(val)
      } else if (this.batch.operate === 'customImport') {
        this.customUpdateImport(val)
      }
      this.batch = {
        visible: false,
        title: '',
        operate: ''
      }
    },
    // 删除执行操作
    async delCehckList (type, info) {
      // info 1为列表选中删除 2为选择时间删除
      // info 为批量操作返回的数据
      if (type === 1) {
        const param = {
          approvalId: this.applyInfo.id
        }
        let arr = this.multipleSelection.map(item => item.approvingId)
        param.approvingId = arr.length === 1 ? arr[0] : arr
        if (this.spaceid) {
          param.spaceid = this.spaceid
        }
        else if (this.upaceid) {
          param.upaceid = this.upaceid
        }
        // 删除接口
        const res = await axiosBase(param, "/api/deleteapproving")
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }
      } else {
        let param = {
          approvalId: this.applyInfo.id,
          reportFormId: this.isAllData.reportFormId,
          type: 0,
          curpage: 1,
          pagesize: 10000,
          cateId: -1
        };
        const searchQuery = typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query
        const q = {
          ...searchQuery,
          ...this.organizationalParameters
        }
        if (info.radio === 2) {
          param.query = q
          if (this.isSearchStatus && this.searchText) {
            param.key = this.searchText
          }
          if (this.isSearchStatus && this.searchCompQuery && Object.keys(this.this.searchCompQuery).length) {
            param.query = {
              ...param.query,
              ...this.searchCompQuery
            }
          }
        } else if (info.radio === 3) {
          param.query = { 'date_timeof': info.time, ...this.organizationalParameters }
        }
        if (param.query) {
          param.query = { ...param.query, ...this.querys }
        } else {
          param.query = this.querys
        }
        param = {
          ...param,
          ...this.ruledata
        }
        const res = await deletebycondition(param)
        if (res.code === 0) {
          this.$message.success(res.msg || '删除成功!')
        } else {
          this.$message.error(res.msg || '删除失败!')
        }
      }
      this.$emit('updateTable', { query: this.searchCriteria.query })
    },
    // 批量修改执行操作
    async updateCheckList (type, info) {
      let param = {
        approvalId: this.applyInfo.id,
        reportFormId: this.isAllData.reportFormId,
        type: 0,
        curpage: 1,
        pagesize: 10000,
        cateId: -1,
        conditionconfig: info.conditionconfig
      }
      const searchQuery = typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query
      const q = {
        ...searchQuery,
        ...this.organizationalParameters
      }
      if (type === 1) {
        param.approvingIds = this.multipleSelection.map(item => item.approvingId).join(',')
      } else if (type === 3) {
        param.query = { 'date_timeof': info.time,...this.organizationalParameters }
      } else if (type === 2) {
        param.query = q
      }
      if (info.isarchive !== "") param.isarchive = info.isarchive
      if (param.query) {
        param.query = { ...param.query, ...this.querys }
      } else {
        param.query = this.querys
      }
      param = {
        ...param,
        ...this.ruledata
      }
      const res = await batchupdatedata(param)
      if (res.code === 0) {
        ElMessage({ type: "success", message: "操作成功" })
        this.$emit('updateTable', { query: this.searchCriteria.query })
      } else {
        ElMessage({ type: "error", message: res.msg || '操作失败' })
      }
    },
    // 导出报表操作
    exportexcel(info) {
      if (this.isPivot) {
        if (this.exportBtnType && this.exportBtnType !== 'before') {
          const objType = {
            'cur': 4,
            'all': 5
          }
          info.radio = objType[this.exportBtnType]
        }
        this.$emit('exportPivot', info)
      } else {
        this.$emit('progress-show', true)
        // 固定参数
        let param = {
          approvalId: this.applyInfo.id,
          curpage: 0,
          cateId: -1,
          pagesize: 0,
        }
        if (this.pageId === '2') {
          param.type = 1
          param.status = '0'
          param.way = '0,1,2,4'
        } else if (this.pageId === '4') {
          param.type = 1
          param.status = '1,2'
          param.way = '0,1,2,4'
        } else if (this.pageId === '5') {
          param.selfuser = 0
        } else {
          param.type = 0
        }
        if (this.exportBtnType && this.exportBtnType !== 'before') {
          const objType = {
            'cur': 4,
            'all': 5
          }
          info.radio = objType[this.exportBtnType]
        }
        param.content = JSON.stringify(info.center)
        const checkShowSet = info.center.filter(item => item.checked)
        checkShowSet.forEach(e => {
          e.checked = true
        });
        param.content = JSON.stringify(checkShowSet)
        param.reportFormId = this.isAllData.reportFormId
        const searchQuery = typeof this.searchCriteria.query === 'string' ? JSON.parse(this.searchCriteria.query) : this.searchCriteria.query
        const q = {
          ...searchQuery,
          ...this.organizationalParameters,
        }
        if (info.radio === 1) {
          param.approvingIds = this.multipleSelection.map(its => its.approvingId).join(',')
        } else if (info.radio === 3) {
          param.query = { 'date_timeof': info.time, ...this.organizationalParameters }
        } else if(info.radio === 2){
          param.query = q
          if (this.isSearchStatus && this.searchText) {
            param.key = this.searchText
          }
          if (this.isSearchStatus && this.searchCompQuery && Object.keys(this.this.searchCompQuery).length) {
            param.query = {
              ...param.query,
              ...this.searchCompQuery
            }
          }
        } else if (info.radio === 4) {
          let curData = this.tableListInfo.tableData
          if (this.detailListData.length !== 0) {
            curData = this.detailListData
          }
          if (curData.length !== 0) {
            param.approvingIds = curData.map(its => its.approvingId).join(',')
          } else {
            this.$message.error('当前页没有数据')
            return
          }
        } else if (info.radio === 5) {
          param.query = {
            ...this.organizationalParameters
          }
        }
        param = {
          ...param,
          ...this.ruledata
        }
        param.query = {
          ...param.query,
          ...this.querys
        }
        if (this.spaceid) {
          param.spaceid = this.spaceid
        }
        else if (this.upaceid) {
          param.upaceid = this.upaceid
        }
        const appid = this.$route.query.approvalId || this.approvalId || this.appid
        if (appid) {
          param.approvalId = appid
        }
        // 第三个参数是导出的接口过期时间
        axiosBase(param, "/api/exportreport", 60 * 1000 * 3).then(async res => {
          if (res && res.code == 0) {
            await filePreview({ url: res.data }, true)
            this.$emit('progress-status', true)
          } else {
            this.$emit('progress-status', '')
          }
        });
      }
    },
    // 导出附件操作
    exportAnnex () {
      this.getFrom()
      let param = {
        approvalId: this.applyInfo.id,
        reportFormId: this.isAllData.reportFormId,
        type: 0,
        zipcontent: '',
        ziptype: this.pageId === '7' ? 0 : 1,
        cateId: '-1'
      }
      param.approvingIds = this.multipleSelection.map(item => item.approvingId).join(',')
      console.log(1)
      const q = {
        ...this.querys,
        ...this.organizationalParameters
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.accessoryRef.openAccessory(param, q);
        }, 10);
      })
    },
    // 数据筛选操作
    goFilter(e) {
      if (JSON.stringify(e) !== '{}') {
        this.$emit('updateTable', { query: JSON.stringify(e) })
      } else {
        delete this.searchCriteria.query
        this.$emit('updateTable', {})
      }
    },
    // 上传区块链操作
    blockchainUpload () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择要上链的数据');
      } else {
        let id_array = this.multipleSelection.map((item) => item.approvingId)
        let param = {};
        param.approvalId = this.approvalId || this.applyInfo.id
        param.approvingIds = id_array
        addcochain(param).then(res => {
          if (res.code === 0) {
            setTimeout(() => {
              this.$message.success('上链成功')
              this.$emit('updateTable', {})
            }, 500)
          } else {
            this.$message.error(res.msg);
          }
        }).catch(error => {
          console.log('区块链上链报错', error)
        })



      }
    },
    // 取消上传区块链
    closeUploadBlock () {
      this.blockchainChange = false
      this.$emit('uploadBlock', false)
    },
    closeApprove () {
      // 取消批量审批
      this.approveChange = false
    },
    // 批量审批的刷新
    batchRefresh(){
      this.$emit('updateTable', {});
    },
    allApprove (isAll) {
      // 处理全部审批
      if ((!isAll && this.multipleSelection.length === 0) || (isAll && this.tableListInfo.tableData.length === 0)) {
        this.$message.error("请选择需要处理的数据!");
        return false;
      }
      this.allBatch = isAll;
      if (
        (isAll && this.tableListInfo.tableData.length > 50) ||
        (!isAll && this.multipleSelection.length > 50)
      ) {
        this.maximumLimit();
      } else {
        this.isBatch = true;
      }
    },
    maximumLimit(){
      const that = this;
      this.$statusMsg.message({
        title: "批量审批不能多于50条，本次处理前50条数据，是否继续？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmFun: function (action) {
          if (action === "confirm") {
            that.isBatch = true;
          }
        },
      });
    },
    openApprove () {
      // 打开批量审批
    },
    // 处理图标转化
    handleDiffTodo (type) {
      // 判断是否处理图标和文本
      const flag = type === 'icon'
      switch (this.info.info.bindingFunction) {
        // 填写表单
        case 'write-table':
          return flag ? 'icon-a-tianxieziliao2x' : '新增'
        case 'all-write-table':
          return flag ? 'icon-a-tianxieziliao2x' : '批量新增'
        // 字段显示设置
        case 'filed-show':
          return flag ? 'icon-a-ziduan2x' : '显示'
        // 批量操作
        case 'all-action':
          return flag ? 'icon-a-piliangbianji2x' : '批量操作'
        // 批量导入
        case 'all-in':
          return flag ? 'icon-a-daoru2x' : '导入'
        case 'all-in-custom':
          return flag ? 'icon-a-daoru2x' : '自定义数据导入'
        case 'all-in-all':
          return flag ? 'icon-a-daoru2x' : '全部数据导入'
        case 'all-in-person':
          return flag ? 'icon-a-daoru2x' : '个人数据导入'
        // 批量审批
        case 'all-approve':
          return flag? 'icon-shenhe' : '批量审批'
        // 批量删除
        case 'all-del':
          return flag ? 'icon-a-shanchu2x' : '删除'
        // 批量修改
        case 'all-edit':
          return flag ? 'icon-a-piliangbianji2x' : '批量修改'
        // 批量导出报表
        case 'all-out-table':
          return flag ? 'icon-daochubaobiao' : '导出'
        // 批量导出附件
        case 'all-out-annex':
          return flag ? 'icon-a-daochufujian2x' : '下载附件'
        // 上传区块链
        case 'all-upload':
          return flag ? 'icon-a-daochufujian2x' : '上传区块链'
        // 数据筛选
        case 'data-screen':
          return flag ? 'icon-a-shaixuan2x' : '筛选'
        // 应用任务
        case 'apply-action':
          return flag ? 'icon-a-biaodanguanli2x' : '应用任务'
        // 全部标记已读
        case 'all-already':
          return flag ? 'icon-a-shaixuan2x' : '全部标记已读'
        // 未读筛选
        case 'unread':
          return flag ? 'icon-a-shaixuan2x' : '未读筛选'
        // 已读
        case 'already-read':
          return flag ? 'icon-a-shaixuan2x' : '已读筛选'
        // 站内应用
        case 'inside':
          return flag ? 'icon-a-biaodanguanli2x' : '站内应用'
        // 站内应用
        case 'todoinside':
          return flag ? 'icon-yingyong' : '站内应用'
        // 外部链接
        case 'todooutside':
          return flag ? 'icon-a-qukuailian2x' : '外部链接'
        // 外部链接
        case 'outside':
          return flag ? 'icon-a-qukuailian2x' : '外部链接'
        case 'edit':
          return flag ? 'icon-bianji' : '编辑'
        case 'del':
          return flag ? 'icon-shanchu5' : '删除'
        case 'dataLog':
          return flag ? 'icon-a-chakan2x' : '数据日志'
        case 'blockchain':
          return flag ? 'icon-guanliankongjian' : '区块链'
        case 'qrCode':
          return flag ? 'icon-erweima-' : '写入二维码'
        case 'lookQrCode':
          return flag ? 'icon-erweima-' : '查看二维码'
        case 'dataArchiving':
          return flag ? 'icon-guidang' : '数据归档'
        case 'custom-scene':
          return flag ? 'WSiconfont WSicon-Send' : '自定义场景'
        case 'app-detail':
          return flag ? 'icon-sousuo' : '查看'
        case 'app-print':
          return flag ? 'el-icon-printer' : '打印'
        case 'report-print':
          return flag ? 'el-icon-printer' : '报表打包下载'
        case 'app-report-print':
          return flag ? 'el-icon-printer' : '应用内报表打包下载'
        case 'list-todo':
          return flag ? 'icon-zhongmingming' : '修改'
        case 'continue':
          return flag ? 'icon-faqi' : '继续写'
        case 'again':
          return flag ? 'icon-shuaxin' : '重新写'
        // 默认
        default:
          return flag ? 'icon-dianji' : '默认'
      }
    }
  },
  inject: {
    homeId: {
      default: null
    }
  },
  computed: {
    curAppId() {
      return this.applyInfo.approvalId || this.applyInfo.id || this.approvalId
    },
    isPivot() {
      if (this.tableConfig.tableStyleField && this.tableConfig.tableStyleField.filedType) {
        return this.tableConfig.tableStyleField.filedType === 'pivot'
      } else {
        return false
      }
    },
    isAnnotation () {
      return this.info.info.annotationInfo && this.info.info.annotationInfo.isAnnotation
    },
    todoList() {
      let li = this.info.info.todoList
      li = li.filter(item => {
        return isConditionAppen(item.conditionAppen, this.tableData)
      })
      return li
    },
    getBtnText() {
      let text = this.info.info.text || this.handleDiffTodo("text")
      if (this.isTable && this.tableData && this.info.info.id === 6) {
        if (this.tableData.archive) {
          text = '解除归档'
        } else {
          text = '未归档'
        }
      }
      if (this.isAiCheck) text = this.info.info.btnName
      return text
    },
    getFontStyle () {
      // 颜色等于#ccc就是默认值不用修改
      const fontStyle = JSON.parse(JSON.stringify(this.info.fontStyle || this.fontStyle))
      if (fontStyle && fontStyle.color === '#ccc') {
        fontStyle.color = '#333'
      }
      fontStyle.whiteSpace = 'nowrap'
      return fontStyle
    },
    getBtnStyle () {
      let style = {}
      if (this.isCard) {
        style = {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }
      return style
    },
    getRadius () {
      const obj = {
        rightAngle: '0',
        fillet: '4px',
        fullRoundedCorner: '100%'
      }
      return {
        borderRadius: obj[this.info.info.buttonRadius] || '4px'
      }
    },
    btnBg () {
      let bg = {}
      if (this.info.info.buttonBackground) {
        const buttonBackground = this.info.info.buttonBackground
        if (buttonBackground.type === 0) {
          bg = {
            background: buttonBackground.color
          }
        } else {
          bg.background = `url(${this.$imgurl}${buttonBackground.image}) no-repeat`
          bg.backgroundSize = '100% 100%'
        }
      }
      return bg
    },
    isAllData () {
      // const data = (this.pageId !== '7' || this.pageId !== '6') ? this.powerData[0] : this.powerData[1]
      if (this.powerData) {
        const data = Object.values(this.powerData).filter((item)=>{
          if (this.pageId === '7' || this.pageId === '6') {
            return !item.userId
          } else {
            return !!item.userId
          }
        })
        return data[0] || {}
      } else {
        return {}
      }
    },
    handleDiffText () {
      switch (this.info.info.bindingFunction) {
        // 填写表单
        case 'write-table':
          return '新增'
        // 字段显示设置
        case 'filed-show':
          return '显示'
        // 批量操作
        case 'all-action':
          return '批量操作'
        // 批量导入
        case 'all-in':
          return '导入'
        // 批量审批
        case 'all-approve':
          return '批量审批'
        // 批量删除
        case 'all-del':
          return '删除'
        // 批量修改
        case 'all-edit':
          return '批量修改'
        // 批量导出报表
        case 'all-out-table':
          return '导出'
        // 下载附件
        case 'all-out-annex':
          return '下载附件'
        // 上传区块链
        case 'all-upload':
          return '上传区块链'
        // 数据筛选
        case 'data-screen':
          return '筛选'
        // 应用任务
        case 'apply-action':
          return '应用任务'
        // 全部标记已读
        case 'all-already':
          return '全部标记已读'
        // 未读筛选
        case 'unread':
          return '未读筛选'
        // 未读筛选
        case 'custom-scene':
          return '自定义场景'
        // 已读
        case 'already-read':
          return '已读筛选'
        // 已读
        case 'inside':
          return '站内应用'
        // 已读
        case 'todoinside':
          return '站内应用'
        case 'edit':
          return '编辑'
        case 'del':
          return '删除'
        case 'dataLog':
          return '数据日志'
        case 'blockchain':
          return '区块链'
        case 'qrCode':
          return '写入二维码'
        case 'lookQrCode':
          return '查看二维码'
        case 'dataArchiving':
          return '数据归档'
        case 'app-detail':
          return '查看'
        case 'app-print':
          return '打印'
        case 'report-print':
          return '报表打包下载'
        case 'app-report-print':
          return '应用内报表打包下载'
        case 'list-todo':
          return '修改'
        // 默认
        default:
          return '默认'
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.all-out-table {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &-btn {
    &:first-of-type {
      margin-top: 0;
    }
    width: 128px;
    height: 34px;
    border-radius: 2px;
    box-sizing: border-box;
    border: 1px solid #DDDFE6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 10px;
    color: #666666;
  }
}

::v-deep .img-import-content {
  &-item {
    color: #000000;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: solid 1px #F1F2F3;
    &:last-of-type {
      border-bottom: none;
    }
    &:hover {
      color: #4e86ff;
    }
  }
}

.button-annotation {
  display: flex;
  align-items: center;
  &-icon {
    margin-left: 5px;
    .WSiconfont {
      font-size: 18px;
      cursor: pointer;
    }
  }
}


.button-reveal {
  width: 100%;
  height: 100%;
  --theme-color: #4e86ff;
  $themeColor: var(--theme-color);
  display: flex;
  .choose-btn {
    display: flex;
    align-items: center;
    &-item {
      padding: 0 16px;
      height: 30px;
      border-radius: 4px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      cursor: pointer;
      .WSiconfont {
        margin-right: 4px;
        padding-top: 2px;
      }
      span {
        user-select: none;
      }
    }
    &-all {
      background-color: #4E86FF;
      border: solid 1px #4E86FF;
      color: #fff;
      margin-right: 8px;
    }
    &-cancle {
      border: 1px solid #F56C6C;
      background-color: #FEFFFF;
      color: #F56C6C;
    }
  }
  &-chekc-field {
    display: flex;
    align-items: center;
    height: 100%;
    ::v-deep .el-checkbox {
      .el-checkbox__label {
        padding-left: 5px;
      }
    }
  }
  .WSiconfont{
    font-size: 16px !important;
  }
  .btn-four{
    display: flex;
    align-items: center;
    height: 100%;
    &-text {
      color: $themeColor !important;
      cursor: pointer;
      font-size: 14px;
      margin: 0 5px;
    }
  }
  .btn-five {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100%;
    border: 1px $themeColor solid;
    box-sizing: border-box;
    width: fit-content;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    color: $themeColor;
    width: 100%;
    span {
      padding: 0 10px;
    }
  }
  .icon-img {
    width: 20px;
    height: 20px;
  }
  .icon-shanchu5{
    color: #e47470 !important;
  }
  &:hover {
    .btn-two,
    .btn-three {
      .iconfont {
        color: $themeColor !important;
      }
      span {
        color: $themeColor !important;
      }
    }
  }
  ::v-deep .el-dropdown {
    height: 100%;
  }
  .el-icon-printer{
    font-size: 16px !important;
  }
  .all-todo {
    display: flex;
    height: 100%;
    align-items: center;
    span {
      color: #666666;
      margin: 0 5px;
    }
  }

  ::v-deep .upload-block {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    .el-button {
      padding: 5px;
    }
  }
  .btn-one {
    display: flex;
    align-items: center;
    justify-content: center;
    width: inherit;
    height: 100%;
    background: $themeColor;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    color: #fff;
    span {
      padding: 0 10px;
      line-height: 30px;
      color: #fff;
    }
  }
  .btn-popover {
    height: 30px;
    // display: inline-block;
    display: flex;
    align-items: center;
    .el-popover__reference-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  .btn-four,
  .btn-two,
  .btn-three {
    border-radius: 4px;
  }
  .btn-two,
  .btn-three {
    width: 100%;
    height: 100%;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: $themeColor;
    cursor: pointer;
    .iconfont {
      color: #333;
      font-size: 14px;
      margin-left: 5px;
    }
    span {
      margin: 0 5px;
      color: #666666;
    }
  }
}

.card-button-reveal {
  cursor: pointer;
  :deep(.btn-one), :deep(.btn-two), :deep(.btn-three), :deep(.btn-five), :deep(.el-tooltip__trigger) {
    width: 100% !important;
  }
  :deep(.btn-four) {
    height: 100%;
    .btn-four-text {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
::v-deep .popUps {
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    .el-dialog__header {
      padding: 18px;
      background-color: #F5F5F5;
      border-radius: 14px 14px 0 0;
    .el-dialog__title{
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    .el-dialog__headerbtn{
      top: 8px;
      font-size: 20px;
    }
    .el-dialog__body {
      padding: 5px;
    }
  }
}
/* 修改全屏样式 */
.fullscreen-progress {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 3000 !important; // 确保在最上层显示
    margin: 0 !important;
    transform: none !important;
}

.ai-check-btn {
  display: flex;
  padding: 8px 24px;
  font-size: 16px;
  color: #4550DC;
  background-color: #FFF;
  border: none;
  border-radius: 27px;
  cursor: pointer;
  /* 初始阴影设置 */
  box-shadow: 0px 0px 16px 0px rgba(69, 80, 220, 0.1);
  /* 过渡动画 */
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  &:hover {
    box-shadow: 0 8px 15px rgba(47, 78, 233, 0.2);
    transform: translateY(-2px);
  }
  &:active {
    box-shadow: 0 2px 3px rgba(47, 78, 233, 0.2);
    transform: translateY(0);
  }
  .icon-img {
    margin-right: 4px;
  }
}
</style>

<style lang="scss">
.container-btn-pop {
  min-width: fit-content !important;
  .container-btn-list-l {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .button-reveal {
      width: fit-content;
      margin-bottom: 10px;
      margin-right: 0 !important;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.img-import-btn-pop {
  padding: 0;
}
</style>
